export type SlashToken = { start: number; end: number; query: string };

// A slash only opens the picker at a word boundary, so URLs (http://) and paths (and/or) don't trigger it.
export function activeSlashToken(
  value: string,
  caret: number
): SlashToken | null {
  let start = -1;
  for (let i = caret - 1; i >= 0; i--) {
    const ch = value[i]!;
    if (ch === "/") {
      start = i;
      break;
    }
    if (/\s/.test(ch)) return null;
  }
  if (start === -1) return null;
  if (start > 0 && !/\s/.test(value[start - 1]!)) return null;

  let end = value.length;
  for (let i = caret; i < value.length; i++) {
    if (/\s/.test(value[i]!)) {
      end = i;
      break;
    }
  }

  return { start, end, query: value.slice(start + 1, caret) };
}

export function ghostSuffix(query: string, name: string): string {
  if (name.length <= query.length) return "";
  if (!name.toLowerCase().startsWith(query.toLowerCase())) return "";
  return name.slice(query.length);
}

export function slashCompletionSuffix(
  token: SlashToken | null,
  caret: number,
  targetName: string | null
): string {
  if (!token || caret !== token.end || !targetName) return "";
  return ghostSuffix(token.query, targetName);
}
